import { render, staticRenderFns } from "./QuickNotificationItem.vue?vue&type=template&id=60e8a54c&scoped=true&"
import script from "./QuickNotificationItem.vue?vue&type=script&lang=ts&"
export * from "./QuickNotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./QuickNotificationItem.vue?vue&type=style&index=0&id=60e8a54c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8a54c",
  null
  
)

export default component.exports